import { com } from '@eidu/form'
import { Stack } from '@mui/material'
import React from 'react'
import Collapsable from './Collapsable'
import SemanticLinksItem from '../input/SemanticLinksItem'
import AuthenticationContext from '../../api/authorization/AuthenticationContext'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import allSemanticLinkKeyConfigurations = com.eidu.sharedlib.entity.analytics.allSemanticLinkKeyConfigurations

type SemanticLinksStackProps = {
  authContext: AuthenticationContext
  entityTypes: readonly EntityType[]
  entityType: EntityType
  semanticLinks: readonly SemanticLink[]
  onSemanticLinksChange: () => void
}

const SemanticLinksStack = ({
  authContext,
  entityTypes,
  entityType,
  semanticLinks,
  onSemanticLinksChange,
}: SemanticLinksStackProps) => (
  <Collapsable title={entityType.name} key={entityType.id.toString()}>
    <Stack spacing={1}>
      {allSemanticLinkKeyConfigurations
        .asJsReadonlyArrayView()
        .filter(({ onTypeKind }) => onTypeKind === entityType.kind)
        .map((semanticLinkKeyConfiguration) => (
          <SemanticLinksItem
            authContext={authContext}
            key={semanticLinkKeyConfiguration.key.toString()}
            entityType={entityType}
            entityTypes={entityTypes}
            semanticLinks={semanticLinks}
            semanticLinkKeyConfiguration={semanticLinkKeyConfiguration}
            onSemanticLinksChange={onSemanticLinksChange}
          />
        ))}
    </Stack>
  </Collapsable>
)

export default SemanticLinksStack
